module.exports = __webpack_public_path__ + "static/media/wild_north.playngo.de9c9a1d.jpeg";